import React from "react";
import { Navigate } from "react-router-dom";

// Authentication related pages
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";
import Overview from "../pages/Dashboard/Overview";
import ResetPassword from "../pages/Authentication/ResetPassword";
import Test from "../pages/Test";
import Reviews from "../pages/Dashboard/Reviews";
import ReviewHistory from "../pages/Dashboard/ReviewHistory/ReviewHistory";
import MeetingRooms from "../pages/Bookings/MeetingRooms";
import MeetingRoomDetails from "../pages/Bookings/MeetingRooms/MeetingRoomDetails";
import AddMeetingRoom from "../pages/Bookings/MeetingRooms/AddMeetingRoom";
import Workspace from "pages/Bookings/Workspace";
import WorkspaceDetails from "pages/Bookings/Workspace/WorkspaceDetails";
import AddWorkspace from "pages/Bookings/Workspace/AddWorkspace";
import Workshop from "pages/Bookings/Workshop";
import WorkshopDetails from "pages/Bookings/Workshop/WorkshopDetails";
import AddWorkshop from "pages/Bookings/Workshop/AddWorkshop";
import WorkshopRequests from "pages/Bookings/Workshop/WorkshopRequests";
import Branches from "pages/Management/Branches";
import BranchDetails from "pages/Management/Branches/BranchDetails";
import AddBranch from "pages/Management/Branches/AddBranch";
import Cities from "pages/Management/Cities";
import Amenities from "pages/Management/Amenities";
import Users from "pages/Users";
import UserDetails from "pages/Users/UserDetails";
import Roles from "pages/Roles";
import ResetNewPassword from "pages/Authentication/ResetNewPassword";
import Rewards from "pages/Rewards/Rewards";
import CashBack from "pages/Rewards/CashBack";
import RewardPage from "pages/Rewards/RewardPage";
import Coupons from "pages/Coupons/Coupons";
import AddEditCoupon from "pages/Coupons/AddEditCoupon";
import Settings from "pages/Management/Settings/Settings";
import IntroductionPage from "pages/Management/Settings/IntroductionPage";
import Closures from "pages/Management/Closures/Closures";
import AddClosure from "pages/Management/Closures/AddClosure";
import ClosureDetails from "pages/Management/Closures/ClosureDetails";
import Notifications from "pages/Management/Settings/Notifications";
import PrivacyAndSecurity from "pages/Management/Settings/PrivacyAndSecurity";
import CancellationPolicies from "pages/Management/Settings/CancellationPolicies";
import TermsAndConditions from "pages/Management/Settings/TermsAndConditions";
import Orders from "pages/Bookings/Orders/Orders";
import OrderDetails from "pages/Bookings/Orders/OrderDetails";
import Customers from "pages/Users/Customers/Customers";
import CustomerDetails from "pages/Users/Customers/CustomerDetails/CustomerDetails";
import Referral from "pages/Rewards/Referral";
import CustomizedRefund from "pages/Management/Settings/GlobalSettings";
import WebsiteRequests from "pages/Bookings/WebsiteRequests/WebsiteRequests";
import APILogs from "pages/Management/APILogs/APILogs";
import APILogsDetails from "pages/Management/APILogs/APILogDetails";
import SignUp from "pages/Authentication/SignUp";
import WelcomeMessage from "pages/WelcomePages/WelcomeMessage";
import PlanPicker from "pages/WelcomePages/PlanPicker";
import OrgnisationForm from "pages/WelcomePages/OrgnisationForm";
import CheckVerificationStatus from "pages/WelcomePages/CheckVerificationStatus";
import Verification from "pages/WelcomePages/Verification";
import MyPlan from "pages/Membership/MyPlan";
import SubscriptionCheckout from "pages/WelcomePages/SubscriptionCheckout";
import RedirectUrl from "pages/WelcomePages/RedirectUrl";
import Office from "pages/Bookings/Office";
import OfficeDetails from "pages/Bookings/Office/OfficeDetails";
import AddOffice from "pages/Bookings/Office/AddOffice";
import HotDesks from "pages/Bookings/HotDesks";
import AddHotDesk from "pages/Bookings/HotDesks/AddHotDesk";
import HotDeskDetails from "pages/Bookings/HotDesks/HotDeskDetails";
import Offers from "pages/Offers/Offers";
import AddEditOffer from "pages/Offers/AddEditOffer";
import OfferDetails from "pages/Offers/OfferDetails";
import AcceptOrganisationInvitation from "pages/WelcomePages/AcceptOrganisationInvitation";
import SetNewPassword from "pages/WelcomePages/SetNewPassword";
import AutoRedirectUrl from "pages/Authentication/AutoRedirectUrl";
import TapOnboarding from "pages/MerchantOnboarding";

const authProtectedRoutes = [
  { path: "/test", element: <Test /> },
  // DASHBOARD
  // { path: "/dashboards/overview", element: <h1>Dashboard</h1> },
  { path: "/dashboards/overview", element: <Overview /> },
  { path: "/dashboards/reviews", element: <Reviews /> },
  { path: "/dashboards/reviews/review-history", element: <ReviewHistory /> },
  // BOOKINGS
  { path: "/bookings/bookings", element: <Orders /> },
  { path: "/bookings/bookings/booking-details", element: <OrderDetails /> },
  { path: "/bookings/meeting-rooms", element: <MeetingRooms /> },
  {
    path: "/bookings/meeting-rooms/meeting-room-details",
    element: <MeetingRoomDetails />,
  },
  {
    path: "/bookings/meeting-rooms/add-new",
    element: <AddMeetingRoom mode="add" />,
  },
  {
    path: "/bookings/meeting-rooms/update-meeting-room",
    element: <AddMeetingRoom mode="edit" />,
  },
  // WORKSPACE
  { path: "/bookings/workspace", element: <Workspace /> },
  {
    path: "/bookings/workspace/workspace-details",
    element: <WorkspaceDetails />,
  },
  { path: "/bookings/workspace/add-new", element: <AddWorkspace mode="add" /> },
  {
    path: "/bookings/workspace/edit-workspace",
    element: <AddWorkspace mode="edit" />,
  },
  // WORKSHOP
  { path: "/bookings/workshops", element: <Workshop /> },
  {
    path: "/bookings/workshops/workshop-details",
    element: <WorkshopDetails />,
  },
  { path: "/bookings/workshops/add-new", element: <AddWorkshop mode="add" /> },
  {
    path: "/bookings/workshops/update-workshop",
    element: <AddWorkshop mode="edit" />,
  },
  {
    path: "/bookings/workshops/edit-workshop-request",
    element: <AddWorkshop mode="editWorkshopRequest" />,
  },
  {
    path: "/bookings/workshops/workshops-requests",
    element: <WorkshopRequests />,
  },
  // {
  //   path: "/bookings/website-requests",
  //   element: <WebsiteRequests />,
  // },
  // OFFICES
  { path: "/bookings/offices", element: <Office /> },
  {
    path: "/bookings/offices/office-details",
    element: <OfficeDetails />,
  },
  { path: "/bookings/offices/add-new", element: <AddOffice mode="add" /> },
  {
    path: "/bookings/offices/edit-office",
    element: <AddOffice mode="edit" />,
  },
  // HOT DESKS
  { path: "/bookings/hot-desks", element: <HotDesks /> },
  { path: "/bookings/hot-desks/add-new", element: <AddHotDesk mode="add" /> },
  {
    path: "/bookings/hot-desks/edit-hot-desk",
    element: <AddHotDesk mode="edit" />,
  },
  { path: "/bookings/hot-desk/hot-desk-details", element: <HotDeskDetails /> },

  // MANAGEMENT
  {
    path: "/management/branches",
    element: <Branches />,
  },
  {
    path: "/management/branches/branch-details",
    element: <BranchDetails />,
  },
  {
    path: "/management/branches/add-branch",
    element: <AddBranch mode="add" />,
  },
  {
    path: "/management/branches/update-branch",
    element: <AddBranch mode="edit" />,
  },

  //REWARDS
  {
    path: "/rewards/rewards",
    element: <Rewards />,
  },
  {
    path: "/rewards/cashback",
    element: <CashBack />,
  },
  {
    path: "/rewards/rewards-page",
    element: <RewardPage />,
  },
  {
    path: "/rewards/coupons",
    element: <Coupons />,
  },
  {
    path: "/rewards/coupons/add-new-coupon",
    element: <AddEditCoupon mode={"add"} />,
  },
  {
    path: "/rewards/coupons/update-coupon",
    element: <AddEditCoupon mode={"edit"} />,
  },
  {
    path: "/rewards/referral",
    element: <Referral />,
  },
  // CITY
  // {
  //   path: "/management/cities",
  //   element: <Cities />,
  // },
  // AMENITIES
  {
    path: "/management/amenities",
    element: <Amenities />,
  },

  // SETTINGS
  {
    path: "/management/settings",
    element: <Settings />,
  },
  {
    path: "/management/settings/introduction-page",
    element: <IntroductionPage />,
  },
  {
    path: "/management/settings/notifications",
    element: <Notifications />,
  },
  {
    path: "/management/settings/privacy-and-security",
    element: <PrivacyAndSecurity />,
  },
  {
    path: "/management/settings/cancellation-policies",
    element: <CancellationPolicies />,
  },
  {
    path: "/management/settings/terms-and-conditions",
    element: <TermsAndConditions />,
  },
  {
    path: "/management/settings/global-settings",
    element: <CustomizedRefund />,
  },
  // {
  //   path: "/management/api-logs",
  //   element: <APILogs />,
  // },
  // {
  //   path: "/management/api-logs/details",
  //   element: <APILogsDetails />,
  // },

  // CLOSURES
  {
    path: "/management/ws-management",
    element: <Closures />,
  },
  {
    path: "/management/ws-management/add-new-closure",
    element: <AddClosure mode="add" />,
  },
  {
    path: "/management/ws-management/update-closure",
    element: <AddClosure mode="edit" />,
  },
  {
    path: "/management/ws-management/closure-details",
    element: <ClosureDetails />,
  },

  // USERS/ROLES/CUSTOMERS
  // {
  //   path: "/users",
  //   element: <Users />,
  // },
  // {
  //   path: "/users/user-details",
  //   element: <UserDetails />,
  // },
  {
    path: "/roles",
    element: <Roles />,
  },

  {
    path: "/customers",
    element: <Customers />,
  },
  {
    path: "/customers/customer-information",
    element: <CustomerDetails />,
  },
  {
    path: "/welcome-message",
    element: <WelcomeMessage />,
  },
  {
    path: "/membership/my-plan",
    element: <MyPlan />,
  },
  {
    path: "/merchant-onboarding",
    element: <TapOnboarding />,
  },

  { path: "/", element: <Navigate to="/dashboards/overview" replace /> }, // Default route to Dashboard
  { path: "/subscription", element: <SubscriptionCheckout /> },
  { path: "/redirectUrl", element: <RedirectUrl /> },
  {
    path: "/plan",
    element: <Offers />,
  },
  {
    path: "/plan/offers",
    element: <Offers />,
  },
  {
    path: "/plan/offers/add-new-offer",
    element: <AddEditOffer mode={"add"} />,
  },
  {
    path: "/plan/offers/update-offer",
    element: <AddEditOffer mode={"edit"} />,
  },
  {
    path: "/plan/offers/offer-details",
    element: <OfferDetails />,
  },
  {
    path: "/plan-picker",
    element: <PlanPicker />,
  },
  {
    path: "/orgnisation-details",
    element: <OrgnisationForm />,
  },
];

const publicRoutes = [
  // { path: "/sign-up", element: <SignUp /> },
  { path: "/autoRedirectUrl", element: <AutoRedirectUrl /> },
  { path: "/account/verification", element: <Verification /> },
  { path: "/accept-invite", element: <AcceptOrganisationInvitation /> },
  { path: "/verification-status", element: <CheckVerificationStatus /> },
  { path: "/login", element: <Login /> },
  { path: "/logout", element: <Logout /> },
  { path: "/reset-password", element: <ResetPassword /> },
  { path: "/reset-new-password/:uuid", element: <ResetNewPassword /> },
  { path: "/set-new-password", element: <SetNewPassword /> },
];

export { authProtectedRoutes, publicRoutes };
